import { FC } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setPackageDealTab } from '@store/slices/portal.slice';
import { PackageDealTab } from '@models';
import { useService } from '@hooks';
import { RxUtils, Tr } from '@utils';
import { notificationService, NotificationType, packageDealService } from '@services';
import { Stack } from '@mui/material';
import { PortalPageTitle } from '@components/portal/common';
import { AddEditPackageForm } from '@components/portal/package-deals';

export const EditPackage: FC = () => {
	const { t } = useTranslation('portal');
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { id = '' } = useParams<{ id: string }>();
	const { data: packageDeal, error } = useService(() => packageDealService.get(id), [id]);

	if (error) {
		return <Navigate to=".." />;
	}

	return (
		<Stack direction="row" sx={{ height: 1.0, maxHeight: 1.0 }}>
			<Stack direction="column" sx={{ height: 1.0, maxHeight: 1.0, flexGrow: 1, paddingY: 5 }}>
				<PortalPageTitle
					paddingX={3}
					title={<Tr.Portal path="package-deal.add-edit-package.edit-title" />}
					subtitle={<Tr.Portal path="package-deal.add-edit-package.edit-subtitle" />}
					onBackButtonClick={() => navigate(-1)}
				/>
				<AddEditPackageForm
					values={packageDeal}
					onSubmit={(values, logo) => {
						RxUtils.promisify(packageDealService.update(id, values, logo), () => {
							notificationService.send({
								type: NotificationType.SUCCESS,
								message: t('package-deal.add-edit-package.update-success')
							});
							dispatch(setPackageDealTab(PackageDealTab.PACKAGES));
							navigate('..');
						});
					}}
				/>
			</Stack>
		</Stack>
	);
};
